/* ZOR — "Complete the Look" set builder.
   Each tile resolves its own variant from the chosen size; the bar totals the
   picked tiles and adds them to the cart in one /cart/add.js request. */
(function () {
  'use strict';

  function money(cents) {
    var el = document.querySelector('[data-money-format]');
    var format = el ? el.getAttribute('data-money-format') : '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (format) {
      var out = format.replace(/\{\{\s*amount[^}]*\}\}/, n);
      if (out !== format) return out;
    }
    return n;
  }

  function init() {
    var root = document.querySelector('[data-zor-set]');
    if (!root || root.dataset.zorSetInit) return;
    root.dataset.zorSetInit = '1';

    var bar = document.querySelector('.zor-set__bar');
    var totalEl = bar && bar.querySelector('[data-zor-set-total]');
    var countEl = bar && bar.querySelector('[data-zor-set-count]');
    var addBtn = bar && bar.querySelector('[data-zor-set-add]');

    var tiles = [].slice.call(root.querySelectorAll('[data-zor-set-item]')).map(function (el) {
      var variants = [];
      var blob = el.querySelector('[data-zor-set-variants]');
      try { variants = JSON.parse(blob.textContent); } catch (e) { variants = []; }
      return {
        el: el,
        variants: variants,
        sizeIndex: parseInt(el.getAttribute('data-size-index'), 10),
        isAnchor: el.hasAttribute('data-zor-set-anchor'),
        picked: true,
        size: null
      };
    });

    // Variants matching a tile's chosen size (or the whole list when sizeless).
    function variantFor(tile) {
      if (tile.sizeIndex < 0) {
        return tile.variants.filter(function (v) { return v.available; })[0] || tile.variants[0] || null;
      }
      if (!tile.size) return null;
      var match = tile.variants.filter(function (v) {
        return String(v.options[tile.sizeIndex]).toUpperCase() === tile.size.toUpperCase();
      });
      return match.filter(function (v) { return v.available; })[0] || match[0] || null;
    }

    function sizeAvailable(tile, value) {
      return tile.variants.some(function (v) {
        return v.available && String(v.options[tile.sizeIndex]).toUpperCase() === String(value).toUpperCase();
      });
    }

    function paint(tile) {
      tile.el.classList.toggle('is-picked', tile.picked);
      var toggle = tile.el.querySelector('[data-zor-set-toggle]');
      if (toggle) toggle.setAttribute('aria-pressed', tile.picked ? 'true' : 'false');

      tile.el.querySelectorAll('[data-zor-set-size]').forEach(function (b) {
        var value = b.getAttribute('data-value');
        var ok = sizeAvailable(tile, value);
        b.disabled = !ok;
        b.classList.toggle('is-on', ok && tile.size === value);
      });

      var variant = variantFor(tile);
      var priceEl = tile.el.querySelector('[data-zor-set-price]');
      if (priceEl && variant) priceEl.textContent = money(variant.price);
    }

    function refresh() {
      var total = 0;
      var count = 0;
      var blocked = false;

      tiles.forEach(function (tile) {
        if (!tile.picked) return;
        var variant = variantFor(tile);
        if (!variant || !variant.available) { blocked = true; return; }
        total += variant.price;
        count += 1;
      });

      if (totalEl) totalEl.textContent = count ? 'Buy the set — ' + money(total) : 'Nothing selected';
      if (countEl) {
        countEl.textContent = blocked
          ? 'Pick an available size for every item in the set.'
          : count + (count === 1 ? ' item' : ' items') + ' · added together in one go';
      }
      if (addBtn) addBtn.disabled = !count || blocked;
    }

    tiles.forEach(function (tile) {
      // Default to the first in-stock size.
      if (tile.sizeIndex >= 0) {
        var first = tile.variants.filter(function (v) { return v.available; })[0];
        if (first) tile.size = String(first.options[tile.sizeIndex]);
      }

      var toggle = tile.el.querySelector('[data-zor-set-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          tile.picked = !tile.picked;
          paint(tile);
          refresh();
        });
      }

      tile.el.querySelectorAll('[data-zor-set-size]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          tile.size = b.getAttribute('data-value');
          if (tile.isAnchor) syncToPdp(tile.size);
          paint(tile);
          refresh();
        });
      });

      paint(tile);
    });

    /* ---------- keep the anchor tile and the main PDP picker in step ---------- */
    var anchor = tiles.filter(function (t) { return t.isAnchor; })[0];

    function pdpSizeInputs() {
      return [].slice.call(document.querySelectorAll('.zor-opt__input')).filter(function (i) {
        var label = i.closest('.zor-opt');
        if (!label) return false;
        var name = label.querySelector('.zor-opt__label');
        return name && /size/i.test(name.textContent);
      });
    }

    function syncToPdp(value) {
      pdpSizeInputs().forEach(function (i) {
        if (i.value.toUpperCase() === String(value).toUpperCase()) {
          i.checked = true;
          i.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (anchor) {
      var inputs = pdpSizeInputs();
      var checked = inputs.filter(function (i) { return i.checked; })[0];
      if (checked) { anchor.size = checked.value; paint(anchor); }

      inputs.forEach(function (i) {
        i.addEventListener('change', function () {
          if (!i.checked) return;
          anchor.size = i.value;
          paint(anchor);
          refresh();
        });
      });
    }

    refresh();

    /* ---------- add the whole set ---------- */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        tiles.forEach(function (tile) {
          if (!tile.picked) return;
          var variant = variantFor(tile);
          if (variant && variant.available) items.push({ id: variant.id, quantity: 1 });
        });
        if (!items.length) return;

        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        var request = window.ZorBag
          ? window.ZorBag.add(items)
          : fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(function (r) {
              if (!r.ok) throw new Error('cart');
              window.location.href = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart' : '/cart';
            });

        request
          .then(function () {
            addBtn.disabled = false;
            addBtn.textContent = label;
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.textContent = label;
            if (countEl) countEl.textContent = (err && err.userMessage) || 'Something went wrong adding the set. Please try again.';
          });
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
